import { Component, Input, OnChanges, OnInit, Output, EventEmitter } from '@angular/core';
import { PublicEventInfo } from 'globals/store/public.model';
import { Exhibitor } from 'globals/store/exhibitors.data';
import publicHelpers from 'src/app/helpers/public-helpers';
import { GalleryCardComponent } from '../sponsors/gallery-card.component';
import { EntityProfileComponent } from 'src/app/components/entities/program-entity-profile.component';
import { CommonModule } from '@angular/common';
@Component({
    selector: 'exhibitor-gallery',
    template: `
<div class="empty-entities-note" *ngIf="isPreview && !exhibitors?.length" [innerHTML]="publicHelpers.strWithBreak(emptyMessage)"></div>
<div *ngIf="!selectedExhibitorId && joiEvent?.exhibitorIds?.length" class="sponsors-holder">
  <div class="sponsor-group-holder">
    <div class="cards-holder">
      <gallery-card *ngFor="let exhibitor of exhibitors" [entity]="exhibitor" (click)="showExhibitor(exhibitor.id)"></gallery-card>
    </div>
  </div>
</div>
<entity-profile 
  *ngIf="selectedExhibitorId && joiEvent.profileExhibitors[selectedExhibitorId] as exhibitor" 
  [backLabel]="entityName" 
  [labelMap]="joiEvent.exhibitor_labels"
  [exhibitor]="exhibitor"
  [hideImages]="!exhibitor?.logoUrl || !!exhibitor.hideLogo"
  [name]="exhibitor.name"
  [hideLabels]="exhibitor.hideLabels"
  [labels]="exhibitor.labels"
  [social]="exhibitor.social"
  [description]="exhibitor.description"
  [logoUrl]="exhibitor.fullLogoUrl || exhibitor.logoUrl"
  [callToAction]="exhibitor.callToAction"
  [callToActionUrl]="exhibitor.callToActionUrl"
  [joiEvent]="joiEvent"
  (goBack)="selectedExhibitorId = null"
></entity-profile>
`,
    styleUrls: ['../sponsors/sponsor-gallery.scss'],
    standalone: true,
    imports: [GalleryCardComponent, EntityProfileComponent, CommonModule],
})
export class ExhibitorGalleryComponent implements OnInit, OnChanges {
  @Input() joiEvent: PublicEventInfo
  @Input() selectedLabelIds: Set<string>
  @Input() isPreview = false
  @Input() entityName
  publicHelpers = publicHelpers
  emptyMessage = "Note: This exhibitors page has no content to display and will be hidden when you publish.\n\nTo include this page, add exhibitors and assign them to a room/location, or adjust the <b>Filter Timeline</b> controls."
  selectedExhibitorId: string
  exhibitors: Exhibitor[]
  @Output() scrollUp: EventEmitter<void> = new EventEmitter()

  ngOnInit() {
    this.filterExhibitors()
  }

  ngOnChanges() {
    setTimeout(() => this.filterExhibitors(), 0)
  }

  filterExhibitors() {
    const { exhibitorIds, profileExhibitors } = this.joiEvent
    const noLabels = !this.selectedLabelIds || !this.selectedLabelIds.size
    this.exhibitors = exhibitorIds.map(id => profileExhibitors[id])
                                  .filter(e => e && (noLabels || (e.labels && e.labels.some(l => this.selectedLabelIds.has(l)))))
    // console.log({ exhibitors: this.exhibitors, joiEvent: this.joiEvent })
  }

  showExhibitor(exhibitorId: string) {
    this.selectedExhibitorId = exhibitorId
    this.scrollUp.emit()
  }


}




